export function objectWithIdAndTitleProperties(obj) {
    return obj.hasOwnProperty("id") && obj.hasOwnProperty("title");
}

export function arrayOfObjectsWithIdAndTitleProperties(arr) {
    return arr.every(objectWithIdAndTitleProperties);
}
